import React, { useEffect, useState } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { loadingStartAction, loadingStopAction } from '../../../redux/actions/loadingActions';
import { useDispatch } from 'react-redux';
import api from '../../../api';
import Label from '../../../components/label/Label';
import { useParams } from 'react-router-dom';

export default function UserPayMentInformation() {
  const [data, setData] = useState([]);

  let { id } = useParams();

  const getAllPaymentMethods = async () => {
    const response = await api.get(`/payment-method/user/${id}/paymentMethods`);
    setData(response.data);
  };

  useEffect(() => {
    getAllPaymentMethods();
  }, []);

  return (
    <TableContainer component={Paper}>
      <Table aria-label="spanning table">
        <TableHead>
          <TableRow>
            <TableCell>UPI/BANK</TableCell>
            <TableCell align="right">Value</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((item) => {
            if (item.type?.toLowerCase() === 'bank') {
              return (
                <TableRow>
                  <TableCell>{item?.bankAccount?.bankName}</TableCell>
                  <TableCell align="right">
                    Account Number: <Label>{item?.bankAccount?.accountNumber}</Label>
                    <br />
                    IFSC Code: <Label>{item?.bankAccount?.ifscCode}</Label>
                  </TableCell>
                </TableRow>
              );
            }
            return (
              <TableRow>
                <TableCell>{item?.upi?.name}</TableCell>
                <TableCell align="right">{item?.upi?.upiId}</TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
